import { render } from "./BranchPlaceMultiselect.vue?vue&type=template&id=30777b64"
import script from "./BranchPlaceMultiselect.vue?vue&type=script&lang=js"
export * from "./BranchPlaceMultiselect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__